<template>
  <page-layout title="팀별 실적">
    <template v-slot:search>
      <loan-performance-team-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <loan-performance-team-detail
        :params-data="paramsData"
        :data="performanceAllData"
        :loading="loading"
        @refresh="refreshData"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LoanPerformanceTeamSearchBar from "@/pages/Loan/components/LoanPerformanceTeam/LoanPerformanceTeamSearchBar.vue";
import {axiosInstance} from "@/util/AxiosModule";
import LoanPerformanceTeamDetail from "@/pages/Loan/components/LoanPerformanceTeam/LoanPerformanceTeamDetail.vue";

export default {
  name: "LoanPerformanceTeam",
  components: {LoanPerformanceTeamDetail, LoanPerformanceTeamSearchBar, PageLayout},
  data() {
    return {
      paramsData: {},
      performanceAllData: {},
      loading: false
    }
  },
  methods: {
    async getSearch(params) {
      this.paramsData = params;
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/private/performance/performance-team", { params });
        this.performanceAllData = data;
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    refreshData() {
      this.getSearch(this.paramsData);
    }
  }
}
</script>